// removed by extract-text-webpack-plugin
module.exports = {"secondary":"var(--secondary)"};